<app-vtable
  #table
  class="vtable"
  [formHelperService]="formHelperService"
  [modelInfo]="models.Location"
  [fields]="tableFields"
  [filters]="filters"
  (onRowClick)="openLocation($event)"
/>